
import React, { useEffect, useState } from "react";
import axios from "axios";
import Filters from "../ReportTab/Filters";
import AssetTable from "./AssetTable";

const BASE_URL = process.env.REACT_APP_API_URL;
const ENDPOINT = "/dq-hollistic/asset-details";

const DEFAULT_PAGE = 1;
const DEFAULT_PAGE_SIZE = 10;

const AssetsDetails = ({ filters, setFilters, onFilterOptionsChange }) => {
  const { parentDomain, domain, subDomain, product } = filters;

  const [filterOptions, setFilterOptions] = useState({
    parentDomains: [], // keep full tree
  });

  const [rows, setRows] = useState([]);
  const [pagination, setPagination] = useState({
    page: DEFAULT_PAGE,
    pageSize: DEFAULT_PAGE_SIZE,
    totalPages: 0,
    totalCount: 0,
  });
  
  const [page, setPage] = useState(DEFAULT_PAGE);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [sortBy, setsortBy] = useState(null);
  const [sortTableBy,setsortTableBy] =useState(null)
  const [assetCount, setAssetCount] = useState(0);
  const [columnSearch, setColumnSearch] = useState({
  domain_name: "",
  sub_domain_name: "",
  product_name: "",
  data_asset_name: "",
  execution_date: "",
  frequency: "",
  total_dq_score: "",
  region: "",
});

  // Fetch API data
  const fetchData = async (params = {}) => {
    setLoading(true);
    setError(null);

    try {
      const res = await axios.get(`${BASE_URL}${ENDPOINT}`, {
        params: {
          parentDomain: parentDomain === "All Parent Domains" ? "" : parentDomain,
          domain: domain === "All Domains" ? "" : domain,
          subDomain: subDomain === "All Sub Domains" ? "" : subDomain,
          product: product === "All Products" ? "" : product,
          page,
          pageSize,
            sortBy: sortBy,           
  sortOrder: sortTableBy,
          ...params,
          
        },
      });

      setRows(res.data.data || []);
      setPagination(res.data.pagination || pagination);
      setAssetCount(res.data.assetCount || 0);
      // if (res.data.filters && res.data.filters.parent_domains) {
      //   setFilterOptions({
      //     parentDomains: res.data.filters.parent_domains, // keep tree
      //   });
      // }
      if (res.data.filters && res.data.filters.parent_domains) {
  // keep local state if you want, but also notify parent
  setFilterOptions({ parentDomains: res.data.filters.parent_domains });
  if (typeof onFilterOptionsChange === "function") {
    onFilterOptionsChange(res.data.filters.parent_domains);
  }
}
    } catch (err) {
      setError("Failed to fetch data");
    } finally {
      setLoading(false);
    }
  };
const searchTimeoutRef = React.useRef(null);

const handleColumnSearch = (key, value) => {
  const updatedSearch = Object.keys(columnSearch).reduce((acc, col) => {
    acc[col] = col === key ? value : "";
    return acc;
  }, {});
  setColumnSearch(updatedSearch);

  clearTimeout(searchTimeoutRef.current);
  searchTimeoutRef.current = setTimeout(() => {
    fetchData({ [key]: value });
  }, 500);
};



  useEffect(() => {
    fetchData();
  }, [parentDomain, domain, subDomain, product, page, pageSize,sortBy, sortTableBy]);

  // Handle Parent Domain change with auto-select
  const handleParentDomainChange = (e) => {
    const newParent = e.target.value;
    let newDomain = "All Domains";
    let newSubDomain = "All Sub Domains";
    let newProduct = "All Products";

    if (newParent !== "All Parent Domains") {
      const selectedParent = filterOptions.parentDomains.find(
        (pd) => pd.parent_domain === newParent
      );
      if (selectedParent) {
        const relatedDomains = selectedParent.domains || [];
        if (relatedDomains.length === 1) {
          newDomain = relatedDomains[0].domain;
          const subDomains = relatedDomains[0].sub_domains || [];
          if (subDomains.length === 1) {
            newSubDomain = subDomains[0].sub_domain;
            const products = subDomains[0].products || [];
            if (products.length === 1) {
              newProduct = products[0];
            }
          }
        }
      }
    }

    setFilters({
      parentDomain: newParent,
      domain: newDomain,
      subDomain: newSubDomain,
      product: newProduct,
    });
    setPage(1);
  };

  // 🔑 Build filtered options (same logic as RuleDetails)
  let filteredDomains = [];
  let filteredSubDomains = [];
  let filteredProducts = [];

  // Domains
  if (parentDomain !== "All Parent Domains") {
    const selectedParent = filterOptions.parentDomains.find(
      (pd) => pd.parent_domain === parentDomain
    );
    filteredDomains = selectedParent ? selectedParent.domains : [];
  } else {
    filteredDomains = filterOptions.parentDomains.flatMap((pd) => pd.domains || []);
  }

  // SubDomains
  if (domain !== "All Domains") {
    const selectedDomainObj = filteredDomains.find((d) => d.domain === domain);
    filteredSubDomains = selectedDomainObj ? selectedDomainObj.sub_domains : [];
  } else {
    filteredSubDomains = filteredDomains.flatMap((d) => d.sub_domains || []);
  }

  // Products
  if (subDomain !== "All Sub Domains") {
    const selectedSubDomainObj = filteredSubDomains.find(
      (sd) => sd.sub_domain === subDomain
    );
    filteredProducts = selectedSubDomainObj ? selectedSubDomainObj.products : [];
  } else {
    filteredProducts = filteredSubDomains.flatMap((sd) => sd.products || []);
  }

  return (
    <div>
      {/* <Filters
        filterOptions={{
          parentDomains: filterOptions.parentDomains,
          domains: filteredDomains,
          subDomains: filteredSubDomains,
          products: filteredProducts,
        }}
        parentDomain={parentDomain}
        domain={domain}
        subDomain={subDomain}
        product={product}
        onParentDomainChange={handleParentDomainChange}
        onDomainChange={(e) => {
          const newDomain = e.target.value;
          let newSubDomain = "All Sub Domains";
          let newProduct = "All Products";

          const domainObj = filteredDomains.find((d) => d.domain === newDomain);
          const relatedSubDomains = domainObj ? domainObj.sub_domains : [];

          if (relatedSubDomains.length === 1) {
            newSubDomain = relatedSubDomains[0].sub_domain;
            const products = relatedSubDomains[0].products || [];
            if (products.length === 1) {
              newProduct = products[0];
            }
          }

          setFilters((prev) => ({
            ...prev,
            domain: newDomain,
            subDomain: newSubDomain,
            product: newProduct,
          }));
          setPage(1);
        }}
        onSubDomainChange={(e) => {
          const newSubDomain = e.target.value;
          let newProduct = "All Products";

          const subDomainObj = filteredSubDomains.find(
            (sd) => sd.sub_domain === newSubDomain
          );
          const relatedProducts = subDomainObj ? subDomainObj.products : [];

          if (relatedProducts.length === 1) {
            newProduct = relatedProducts[0];
          }

          setFilters((prev) => ({
            ...prev,
            subDomain: newSubDomain,
            product: newProduct,
          }));
          setPage(1);
        }}
        onProductChange={(e) => {
          setFilters((prev) => ({ ...prev, product: e.target.value }));
          setPage(1);
        }}
      /> */}

      <div className="pl-4 pr-4">
        <AssetTable
          tableData={rows}
          loading={loading}
          assetCount={assetCount}
          error={error}
          pagination={pagination}
          onPageChange={(p) => setPage(p)}
           onColumnSearchChange={handleColumnSearch}
  columnSearch={columnSearch}
          onPageSizeChange={(s) => {
            setPageSize(s);
            setPage(1);
          }}
           onSortChange={(column, order) => {  
    setsortBy(column);
    setsortTableBy(order)
    console.log("sort by asc", order)
        console.log("sort by asc", column)

  }}
        />
      </div>
    </div>
  );
};

export default AssetsDetails;
